import { Box, ThemeProvider, Typography, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { BoxForm, FormControlDefault, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { RegisterLayout } from 'app/shared/layout/register/RegisterLayout';
import { RegisterTitle } from 'app/shared/layout/register/RegisterTitle';
import { toast } from 'react-toastify';
import { createEntity, getEntity, reset, updateEntity } from './tire-manufacturer.reducer';

export const TireManufacturerUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const hasSaved = useRef(false);

  const tireManufacturerEntity = useAppSelector(state => state.tireManufacturer.entity);
  const loading = useAppSelector(state => state.tireManufacturer.loading);
  const updating = useAppSelector(state => state.tireManufacturer.updating);
  const updateSuccess = useAppSelector(state => state.tireManufacturer.updateSuccess);

  const [formData, setFormData] = useState<{
    image?: string | null;
    imageContentType?: string | null;
    name?: string | null;
  }>({
    image: null,
    imageContentType: null,
    name: null,
  });

  useEffect(() => {
    if (!isNew && tireManufacturerEntity) {
      setFormData({
        image: tireManufacturerEntity?.image,
        imageContentType: tireManufacturerEntity?.imageContentType,
        name: tireManufacturerEntity?.name,
      });
    }
  }, [tireManufacturerEntity]);

  const handleClose = () => {
    props.history.push('/tire-manufacturer' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess && hasSaved.current) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...tireManufacturerEntity,
      ...values,
    };

    hasSaved.current = true;

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!formData?.name) {
      return toast.error('Insira um nome (exemplo: Bridgestone)');
    }

    saveEntity(formData);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <RegisterLayout>
          <Box sx={{ width: { xs: '95%', sm: '70%', lg: '50%' } }} justifyContent={'center'}>
            <RegisterTitle isNew={isNew} contentKey={'fleetSenseApp.tireManufacturer'} />
            <Box>
              {loading ? (
                <Box>
                  <Typography>Loading...</Typography>
                </Box>
              ) : (
                <Box margin={'0 auto'} width={'100%'}>
                  <BoxForm onSubmit={handleSubmit}>
                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.tireManufacturer.name')}</TypographyForms>
                      <TextFieldForms
                        value={formData['name']}
                        id={'tire-manufacturer-name'}
                        data-cy={'name'}
                        name={'name'}
                        onChange={e => handleInputChange('name', e.target.value)}
                      />
                    </FormControlDefault>

                    <RegisterButton />
                  </BoxForm>
                </Box>
              )}
            </Box>
          </Box>
        </RegisterLayout>
      </ThemeProvider>
    </>
  );
};

export default TireManufacturerUpdate;
